module.exports = __webpack_public_path__ + "static/media/question.493592b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/question.png
// module id = 22
// module chunks = 0